import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';

import { PrestamosService } from 'src/app/services/prestamos/prestamos.service';
import { ConsultaPrestamosService } from 'src/app/services/consulta-prestamos/consulta-prestamos.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import Swal from 'sweetalert2';


export interface DialogData
{
    idPostulacion: any,
    tiposRechazo: [],
    tipoRechazo: any,
    email: any,
    nombreCompleto: any,
    nombreProducto: any,
    comentarioRechazo: any
}

@Component({
    selector: 'rechazo-prestamos',
    templateUrl: '../../pages/prestamos/prestamos-rechazar.html',
    styleUrls: ['../../pages/prestamos/prestamos.component.css']
})
export class DialogTipoRechazoPrestamo
{
 tiposRechazo: any

  constructor( public dialogRef: MatDialogRef<DialogTipoRechazoPrestamo>,
    private prestamosService: PrestamosService,
    private consultaPrestamosService:ConsultaPrestamosService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private dialog: MatDialog, )
    { 
      
    
    }
    
    ngOnInit(): void
    { this.loadData() }
    loadData()
    {
      this.consultaPrestamosService.motivoRechazo(4).then
      (
          
          rechazos => {this.tiposRechazo = rechazos
             
            }
      )
      .catch ( error => {console.log(error)
    } )
    
    }
  onRechazarClick()
  {
    Swal.fire({
    allowOutsideClick:false,
    icon:'info',
    text:'Cargando...'
    });
    Swal.showLoading();
    let vm = this
    
    let idMotivoRechazo = this.data.tipoRechazo.split('-')[0]
    let motivoRechazo = this.data.tipoRechazo.split('-')[1]

    this.prestamosService.rechazarPostulacion(this.data.idPostulacion, idMotivoRechazo,
    motivoRechazo, this.data.comentarioRechazo).then(
      () =>
      {
       Swal.close();
         vm.dialogRef.close()
         vm.openAlertDialog('El préstamo se ha rechazado exitosamente.', 'btn-success')
      }
    )
    .catch
    (
      error =>
      {
       Swal.close();
         console.log(error)
         vm.dialogRef.close()
         vm.openAlertDialog('La postulación no se ha podido rechazar.', 'btn-danger')
      }
    )
    }
    
    onCancelarClick(): void { this.dialogRef.close() }
    
    openAlertDialog(mensaje: string, clase: string)
    {
    this.dialog.open(AlertDialogComponent, {
    data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
      })
      }
    }
    